import { useIbMembership } from '@frontends/feature-ib';
import { type PropsWithChildren, type ReactNode, useEffect, useState } from 'react';
import Spinner from '@/components/Spinner';

const MEMBERSHIP_MAX_WAIT_MS = 5_000;

export const IbMembershipGate = ({ children }: PropsWithChildren): ReactNode => {
  const { isPending } = useIbMembership();
  const [isGateOpen, setIsGateOpen] = useState(false);

  // Latch: block only the initial wait; children refetch an errored query on mount, which would flip isPending
  // back to true and bring the spinner (and a layout remount) back in a loop
  if (!isPending && !isGateOpen) {
    setIsGateOpen(true);
  }

  // axiosIb has no timeout; a hanging ib-desk must not hold the app, a late answer just updates the UI
  useEffect(() => {
    if (!isPending || isGateOpen) {
      return undefined;
    }

    const timerId = setTimeout(() => setIsGateOpen(true), MEMBERSHIP_MAX_WAIT_MS);

    return () => clearTimeout(timerId);
  }, [isPending, isGateOpen]);

  if (isPending && !isGateOpen) {
    return <Spinner />;
  }

  return children;
};
